import { CanceledError } from 'axios';

export const KEEP_ALIVE_INACTIVE_PANE_MESSAGE = 'keep-alive inactive pane';

export function isKeepAliveInactivePaneError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const isCanceled =
    typeof CanceledError === 'function'
      ? error instanceof CanceledError
      : error.name === 'CanceledError';

  return isCanceled && error.message === KEEP_ALIVE_INACTIVE_PANE_MESSAGE;
}

export function createKeepAliveInactivePaneError(): CanceledError<unknown> {
  return new CanceledError(KEEP_ALIVE_INACTIVE_PANE_MESSAGE);
}
